import React from "react";
import AddRecordPanel from "../../shared/components/recordList/AddRecordPanel";
import {
  ChemicalRecord,
  createChemicalRecord,
  SelectOptionList,
  TransportRoute
} from "../types/chemicalRecords.types";
import ChemicalRecordForm from "./ChemicalRecordForm";

interface ChemicalAddRecordPanelProps {
  /** Bumped after a successful add to remount the form with a blank draft. */
  draftKey: number;
  hasRecords: boolean;
  onSave: (patch: Partial<ChemicalRecord>) => void;
  chemFunctionOptions: SelectOptionList;
  transportOptions: SelectOptionList;
  transportLabelMap: Record<string, string>;
  onAddRoute: (chemId: string, route: Pick<TransportRoute, "type" | "distance">) => void;
  onUpdateRoute: (chemId: string, routeId: string, patch: Partial<TransportRoute>) => void;
  onRemoveRoute: (chemId: string, routeId: string) => void;
}

/** Dashed "add a new chemical record" panel shown at the bottom of the list. */
const ChemicalAddRecordPanel: React.FC<ChemicalAddRecordPanelProps> = ({
  draftKey,
  hasRecords,
  onSave,
  chemFunctionOptions,
  transportOptions,
  transportLabelMap,
  onAddRoute,
  onUpdateRoute,
  onRemoveRoute
}) => (
  <AddRecordPanel label="Add new chemical record" hasRecords={hasRecords}>
    <ChemicalRecordForm
      key={draftKey}
      rec={createChemicalRecord()}
      isDraft
      chemFunctionOptions={chemFunctionOptions}
      transportOptions={transportOptions}
      transportLabelMap={transportLabelMap}
      onSave={onSave}
      onAddRoute={onAddRoute}
      onUpdateRoute={onUpdateRoute}
      onRemoveRoute={onRemoveRoute}
    />
  </AddRecordPanel>
);

export default ChemicalAddRecordPanel;
